import Breadcrumb from '../atoms/Breadcrumb'
import Container from '../atoms/Container'
import Text from '../atoms/Text'
import Image from 'next/image'
import React from 'react'

function ContentTemplate({ children, breadcrumbs, title }) {
    return (
        <Container type='type0'>
            <Breadcrumb className="py-3 md:py-5" divider="primary" textSize={"text-sm"} data={breadcrumbs} />
            <div className="pt-7 pb-44 md:pt-12 md:pb-52 md:rounded-lg bg-secondary-900 relative overflow-hidden -mx-6 md:mx-0">
                <div className="w-full space-y-8 flex flex-col items-center h-full z-10 relative">
                    <Text variant="" fontWeight="font-semibold" className="text-center text-primary-900 pb-2 px-6 md:px-0 text-2xl md:text-4xl">
                        {title}
                    </Text>
                </div>
                <div className="absolute top-0 left-0 h-full w-full hidden md:block">
                    <Image src="/images/merchantBg.svg" layout="fill" />
                </div>
                <div className="absolute top-0 left-0 h-full w-full md:hidden">
                    <Image src="/images/merchantBgMobile.svg" layout="fill" />
                </div>
            </div>
            <div className="w-full flex justify-center relative -mt-40 z-10 mb-10">
                <div className="w-[100%] lg:w-[95%] text-neutral-800 bg-white shadow-md rounded-lg px-4 py-6 lg:px-10 lg:py-10">
                    {children}
                </div>
            </div>
        </Container>
    )
}

export default ContentTemplate